import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '@/components/ui/dropdown-menu'
import { useTranslation } from 'react-i18next'
import { ChevronDown, UserRoundCog } from 'lucide-react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { Link } from 'react-router-dom'
import { keyBy } from 'lodash'
import UpcomingEvent from 'app/frontend/base/components/UpcomingEvent'
import { useVisibleTeamsForUser } from 'app/frontend/base/hooks/useVisibleTeamsForUser'

const EventNavigationMenu = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()

  const filteredAndSortedTeamReferences = useVisibleTeamsForUser(user)
  const filteredAndSortedUpcomingEvents = user?.upcomingEvents.filter(
    (eventReference) =>
      filteredAndSortedTeamReferences.some(
        (teamReference) => teamReference.id === eventReference.teamId,
      ),
  )

  if (!user) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <span className='flex gap-1 items-center cursor-pointer ml-2 mr-2'>
          <span className='text-sm'>{t(`header.events`)}</span>
          <ChevronDown
            width={12}
            className='ml-0.5 mt-1 opacity-70 hidden max-[420px]:block sm:block'
          />
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {filteredAndSortedUpcomingEvents?.map((eventReference, i) => {
          const teamReference = user.teamReferences.find(
            (ref) => ref.id === eventReference.teamId,
          )

          const participants = keyBy(
            eventReference.participantReferences,
            'characterId',
          )
          const characterReference = user.characterReferences.find(
            (ref) => participants[ref.id.toString()],
          )

          if (!teamReference || !characterReference) return null

          return (
            <div key={i}>
              <Link to={`${teamReference.path}/events/${eventReference.id}`}>
                <DropdownMenuItem>
                  <UpcomingEvent eventReference={eventReference} />
                </DropdownMenuItem>
              </Link>

              <DropdownMenuSeparator />
            </div>
          )
        })}

        {!filteredAndSortedUpcomingEvents ||
        filteredAndSortedUpcomingEvents.length === 0 ? (
          <>
            <DropdownMenuLabel className='text-center font-normal max-w-[20rem]'>
              {t('header.no-upcoming-events')}
            </DropdownMenuLabel>

            {window.location.pathname !== '/profile/characters' && (
              <>
                <DropdownMenuSeparator />
                <Link to='/profile/characters'>
                  <DropdownMenuItem className='w-full flex items-center justify-center gap-2'>
                    <UserRoundCog size={14} /> {t('header.profile')}
                  </DropdownMenuItem>
                </Link>
              </>
            )}
          </>
        ) : (
          <DropdownMenuItem>View all upcoming events</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default EventNavigationMenu
